import React from "react";
import { useSelector } from "react-redux";
import FormatData from "../OptixData/FormatData";

const AuditBasedQuestion = ({time,count}) => {
  const { optixData } = useSelector((state) => state.imageViewerStore);
 // console.log(optixData);
  
  return optixData.map((data) => (
    <>
      <FormatData
        result_data={data.result} 
        auditID={data.audit_id}
        category={data.category}
        store_type={data.store_type}
        question_list_data={data.question_list}
        sos_result={data.sos_result}
        sod_result={data.sod_result}
        //sod_result="What is Share of Display for  Mainline ?:0,What is Share of Display for  Premium care ?:0,What is Share of Display for  Active Baby?:0,What is Share of Display for  Baby Dipers?:0,What is Share of Display for  Pamperswipes?:100"
        time={time}
        count={count}
      />
      {/* <FormatData2 data={data.question_list}/> */}
    </>
  ));
};

export default AuditBasedQuestion;
